export default __webpack_public_path__ + "static/media/twitter_landing.06d2030c.PNG";